import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AndroidIcon,
  IphoneIcon,
  GameIcon,
  FlutterIcon,
  HealthcareIcon,
  ReactIcon,
} from "../../../app-constants";
import { Link } from "gatsby";

const StackItem = [
  {
    icon: AndroidIcon,
    title: "Android app development",
    description: (
      <>
        TekRevol offers the best{" "}
        <Link to="/android-app-development">
          android app development services
        </Link>{" "}
        to the clients worldwide. Our app developers in Florida have a proven
        track record of using cutting-edge technologies like, Java, Kotlin,
        React Native, Fastlane and etc to build state of the art app solutions.
        We’ve helped various industries, and are on the pathway of bringing
        digital transformation.
      </>
    ),
  },
  {
    icon: IphoneIcon,
    title: "Iphone app development",
    description: (
      <>
        With the help of our{" "}
        <Link to="/iphone-app-development" rel="noopener" aria-label="TekRevol">
          iOS app development services
        </Link>{" "}
        , enterprises of different scales can effectively generate
        high-performance native iOS apps by yielding cutting-edge iOS
        development tools and programming languages like Swift, Objective C,
        XCode, and others. Based in Florida, our iOS app services propel your
        app venture, from consumer apps to complex on-demand solutions.
      </>
    ),
  },
  {
    icon: GameIcon,
    title: "Game app development",
    description: (
      <>
        Unveil a game with new ideas and monetize with the help of ads,
        sponsored content, and premium subscribers. Collaborate with an
        experienced{" "}
        <Link to="/game-development" rel="noopener" aria-label="TekRevol">
          game app development company
        </Link>{" "}
        in incorporating AR, VR, Blockchain, and NFTs in gaming environments.
        With our unrivaled services, your game can be the next big thing in this
        vast industry.
      </>
    ),
  },
  {
    icon: FlutterIcon,
    title: "Flutter app development",
    description: (
      <>
        TekRevol can assist you with unmatched digital solutions for Android and
        iOS operating systems by utilizing Flutter as a full-fledged framework
        to develop feature-rich apps. You can be cost-efficient by using{" "}
        <Link
          to="/flutter-app-development"
          rel="noopener"
          aria-label="TekRevol"
        >
          Flutter app development
        </Link>{" "}
        to develop your mobile app due to its cross-platform compatibility. With
        Flutter, you can create efficient and top performing apps that work on
        multiple OS.
      </>
    ),
  },
  {
    icon: HealthcareIcon,
    title: "Healthcare app development",
    description: (
      <>
        TekRevol has extensive experience and expertise in{" "}
        <Link to="https://www.tekrevol.com/healthcare-app-development">
          healthcare app development
        </Link>
        , creating versatile solutions tailored to modernize the intricate tasks
        of your healthcare business. By integrating advanced technologies, we
        develop mobile applications that enhance operational efficiency and
        establish a credible presence in the market.
      </>
    ),
  },
  {
    icon: ReactIcon,
    title: "React Native app development",
    description:
      "TekRevol is completely armed to make use of React native app development to its full potential for accomplishing extensive functionality with effortless performance. By effectively utilizing the top-notch functionality of JavaScript with Synchronous API, we deliver a native experience for your app. Hire our React native app developers now, and fuel your app ideas into reality.",
  },
];

function Improvise(props) {
  return (
    <div className="improvise_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={4}
            className="m-xl-auto m-xxl-0"
          >
            <h2>TekRevol’s Mobile App Development Services in Florida</h2>
            <p className="impro_para">
              Leveraging the ability of our mobile app developers in Florida, we
              deliver custom-made solutions rendering to your business needs.
              You can choose our mobile app development services in Florida and
              get a strong and reliable mobile application that will play a
              critical role in improving your digital existence.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
            <div className="stack_box">
              {StackItem.map((item, index) => (
                <div className="stack_item" key={index}>
                  <div className="stack_title">
                    {item.icon}
                    <h5>{item.title}</h5>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Improvise;
